import { i18n } from '@lingui/core';
import { DEFAULT_LANGUAGE, LOAD_SEARCH_PARAMS } from './constants';
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';

import 'dayjs/locale/en';
import 'dayjs/locale/es';

dayjs.extend(updateLocale);

dayjs.updateLocale('es', {
  meridiem: hour => (hour < 12 ? 'a.m.' : 'p.m.'),
  // Update LT (Time) and LTS (Time with seconds)
  formats: {
    LT: 'h:mm a',
    LTS: 'h:mm:ss a',
    L: 'DD/MM/YYYY',
    LL: 'D [de] MMMM, YYYY',
    LLL: 'D [de] MMMM, YYYY, h:mm a',
    LLLL: 'dddd, D [de] MMMM , YYYY, h:mm a',
    ll: 'D [de] MMM, YYYY',
    lll: 'D [de] MMM, YYYY, h:mm a',
  },
});

export const LANGS = {
  en: { name: 'English' },
  es: { name: 'Español' },
};

const messagesGlob = import.meta.glob('./locales/**/*.mjs', { eager: true });

const LANG_STORAGE_KEY = 'preferred-language';

export const INIT_LANG =
  LOAD_SEARCH_PARAMS.lang in LANGS
    ? LOAD_SEARCH_PARAMS.lang
    : localStorage.getItem(LANG_STORAGE_KEY) in LANGS
      ? localStorage.getItem(LANG_STORAGE_KEY)
      : DEFAULT_LANGUAGE;

function loadMessagesSync() {
  for (const lang of Object.keys(LANGS)) {
    const path = `./locales/${lang}/messages.mjs`;

    if (messagesGlob[path]) {
      const module = messagesGlob[path];
      const messages = module.messages;

      if (messages) {
        i18n.load(lang, messages);
        i18n.loadLocaleData(lang, { plurals: LANGS[lang].plurals });
      }
    }
  }

  i18n.activate(INIT_LANG);
}

loadMessagesSync();

export function setLanguage(locale) {
  i18n.activate(locale);
  dayjs.locale(locale);
  localStorage.setItem(LANG_STORAGE_KEY, locale);
}

export function isCurrentLanguage(locale) {
  return i18n.locale === locale;
}

export { i18n };
